// Vuex data store

import Vuex from 'vuex'
import Vue from 'vue'

import loading from './modules/loading'
import breadcrumbs from './modules/breadcrumbs'
import notifications from './modules/notifications'
import modal from './modules/modal'
import achievements from './modules/achievements'
import glossary from './modules/glossary'
import users from './modules/users'
import terms from './modules/terms'
import periods from './modules/periods'
import feedback from './modules/feedback'
import diligence from './modules/diligence'
import badges from './modules/badges'
import assignments from './modules/assignments'
import steps from './modules/steps'
import partials from './modules/partials'
import submissions from './modules/submissions'
import progress from './modules/progress'
import images from './modules/images'
import groups from './modules/groups'
import schools from './modules/schools'

Vue.use(Vuex)

const modules =  {
    loading,
    breadcrumbs,
    notifications,
    modal,
    achievements,
    glossary,
    users,
    terms,
    periods,
    feedback,
    diligence,
    badges,
    assignments,
    steps,
    partials,
    submissions,
    progress,
    images,
    groups,
    schools,
}

export default new Vuex.Store({
    modules,
    mutations: {
        RESET_ALL (state) {

            for( const module in modules) {
                if ( 'initialState' in modules[module] ) {
                    Vue.set(state, module, modules[module].initialState())
                }
            }

        },
    },
})



// WEBPACK FOOTER //
// ./resources/assets/js/vuex/store.js